import React from 'react';
import {Link} from 'react-router';

const InfoColumns = ({title = '', titleRedirect='', description = '', columns = [], headerAction = null}) => {
    return (
        <React.Fragment>
            <div className={`stats-title green`}>
                <span className='stats-title-text'>
                    {titleRedirect ?
                        <Link to={titleRedirect}>{title}</Link>
                        :
                        title
                    }
                </span>
                {headerAction && (
                    <span className='stats-title-action-wrap'>{headerAction}</span>
                )}
            </div>
            {description && <p className='stats-description'>{description}</p>}
            <div className='stats-info-container'>
                {columns.map((column, index) => (                    
                    <div className={title === 'Closed Since 2022' ? 'stats-info-Closed' : 'stats-info-columns'} key={index}>
                        <div className='stats-info-value'>
                            {column.value}
                        </div>
                        <div className={`stats-info-title ${column.className || ''}`}>
                            {column.key}
                        </div>
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
};

export default InfoColumns;
